import type { ReactNode } from 'react';
import EmptyState from '../../feedback/EmptyState';
import Spinner from '../../feedback/Spinner';

export interface Column<T> {
  key: string;
  header: ReactNode;
  render: (row: T) => ReactNode;
  align?: 'left' | 'right' | 'center';
  width?: string | number;
}

/** Tabela de dados (C-18) com estados de carregando e vazio. */
export default function DataTable<T>({ columns, rows, rowKey, loading, empty = 'Nada por aqui ainda.', rowClassName, onRowClick }: {
  columns: Column<T>[];
  rows: T[] | undefined;
  rowKey: (row: T) => string;
  loading?: boolean;
  empty?: ReactNode;
  rowClassName?: (row: T) => string | undefined;
  onRowClick?: (row: T) => void;
}) {
  if (loading) return <div className="page-loading" style={{ minHeight: 160 }}><Spinner size="lg" /></div>;
  if (!rows?.length) return <EmptyState title={empty} />;
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>{columns.map((c) => <th key={c.key} style={{ textAlign: c.align, width: c.width }}>{c.header}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={rowKey(r)} className={rowClassName?.(r)} onClick={onRowClick ? () => onRowClick(r) : undefined} style={onRowClick ? { cursor: 'pointer' } : undefined}>
              {columns.map((c) => <td key={c.key} style={{ textAlign: c.align }}>{c.render(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
